var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMood3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.14 887.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0af0c;}.cls-2{fill:#ffc73c;}.cls-3{fill:#d49800;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.47,
    y: 621.01,
    width: 434.4,
    height: 47.23,
    rx: 23.61,
    transform: "translate(469.34 1289.25) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 238.57,
    cy: 238.57,
    r: 230.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.57,477.14c131.55,0,238.57-107,238.57-238.57S370.12,0,238.57,0,0,107,0,238.57,107,477.14,238.57,477.14Zm0-460.4c122.32,0,221.84,99.51,221.84,221.83S360.89,460.41,238.57,460.41,16.74,360.89,16.74,238.57,116.25,16.74,238.57,16.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 327.98,
    cy: 181.02,
    r: 29.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 160.67,
    cy: 181.02,
    r: 29.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.24,320.1H311a8.63,8.63,0,0,0,0-17.26H164.24a8.63,8.63,0,1,0,0,17.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.26,830.57A29.78,29.78,0,0,1,278,850.21a33.52,33.52,0,0,1-5.36,18.25q-5.36,8.46-16.54,13.74t-27.8,5.28a107.76,107.76,0,0,1-22.9-2.48,71.44,71.44,0,0,1-20-7.3l12.43-27a57.58,57.58,0,0,0,14.36,5.9,58.18,58.18,0,0,0,14.83,2q6.38,0,10.25-2.18a6.77,6.77,0,0,0,3.88-6.21q0-7.46-12.89-7.45H213.87V820.24l16-16.31H191V776.29h81.07v22.52l-20.19,20.5Q264.51,822.42,271.26,830.57Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood3);
export default __webpack_public_path__ + "static/media/mood-3.655435bd.svg";
export { ForwardRef as ReactComponent };